import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ToastService } from './toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TelemetryService } from './telemetry.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any) {
    const toastService = this.injector.get(ToastService);
    const ngZone = this.injector.get(NgZone);
    const telemetryService = this.injector.get(TelemetryService);

    // 1. Log the full error for Azure Telemetry / Server Logs
    console.error('GlobalErrorHandler Caught Error:', error);
    telemetryService.logException(
      error instanceof Error ? error : new Error(error?.message || 'Unknown error'),
    );

    // 2. Extract a readable message
    let message = 'An unexpected error occurred.';
    if (error instanceof HttpErrorResponse) {
      // Server or connection error
      if (error.status === 0) {
        message = 'Unable to connect to the server. Please check your internet connection.';
      } else if (error.status >= 500) {
        message = 'The server is temporarily unavailable. Please try again later.';
      } else if (error.status >= 400) {
        message = 'There was a problem with your request. Please try again.';
      }

      // Override with a specific backend message only if it exists
      if (error.error && typeof error.error.message === 'string') {
        message = error.error.message;
      }
    } else if (error.rejection) {
      // Unhandled Promise Rejection
      message = error.rejection.message || error.rejection.toString();
    } else if (error.message) {
      // Standard JavaScript Error
      message = error.message;
    } else if (typeof error === 'string') {
      message = error;
    }

    // Do not present dev-mode change detection errors in the UI toast
    if (
      typeof message === 'string' &&
      (message.includes('ExpressionChangedAfterItHasBeenCheckedError') ||
        message.includes('NG0100'))
    ) {
      return;
    }

    // 3. Present it safely inside the Angular Zone so the UI updates
    ngZone.run(() => {
      toastService.present({
        message: message,
        status: 'error',
        icon: 'warning',
      });
    });
  }
}
